export enum EventTargets {
  Moengage = "MOE",
  Clickhouse = "CLICKHOUSE",
  Ems = "EMS",
  Appsflyer = "APPSFLYER",
  Facebook = "FACEBOOK",
}
